import { render } from "./Lessons.vue?vue&type=template&id=85561ad4&ts=true"
import script from "./Lessons.vue?vue&type=script&lang=ts"
export * from "./Lessons.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__